<template>
  <el-dialog title="Adicionar Signatários" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="60%">
    <el-form :model="form" ref="form" :rules="validacao" size="small" label-position="top" :show-message="false">
      <el-row :gutter="22" style="display: flex; justify-content: space-between;">
        <el-col :span="22">
          <el-form-item label="Cliente">
            <el-select 
              v-model="clienteSelecionado"
              :remote-method="recuperarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder=""
              loading-text="Carregando Clientes"
              no-data-text="Nenhum cliente encontrado"
              filterable
              clearable
              @clear="clienteSelecionado = {}"
              @change="preencherFormularioComCliente"
              remote
              reserve-keyword
              :disabled="isTestemunha"
              style="width: 100%"
            >
              <el-option
                v-for="item in listaClientes"
                :key="item.id"
                :label="formatarSelectCliente(item)"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="22" style="display: flex; justify-content: space-between;">
        <el-col :span="10">
          <el-form-item label="Nome" prop="nome">
            <el-input v-model="form.nome" :disabled="!isTestemunha"/>
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item label="Email" prop="email">
            <el-input v-model="form.email" :disabled="!isTestemunha"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="22" style="display: flex; justify-content: space-between;">
        <el-col :span="10">
          <el-form-item label="CPF" prop="cpf">
            <el-input v-model="form.cpf" :disabled="!isTestemunha" v-mask="['###.###.###-##', '##.###.###/####-##']"/>
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item label="Tipo Signatário" prop="tipoSignatario">
            <el-select
              auto-complete="off"
              v-model="form.tipoSignatario"
              clearable
              placeholder
              :disabled="isTestemunha"
              style="width: 100%"
            >
              <el-option 
                v-for="item in tiposSignatarios"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="22" style="display: flex; justify-content: space-between;">
        <el-col :span="10">
          <el-row type="flex" justify="start">
            <el-form-item label=" ">
              <el-checkbox @change="clickTestemunhaCheckBox" v-model="isTestemunha">Adicionar signatario não cadastrado no sistema.</el-checkbox>
            </el-form-item>
          </el-row>
        </el-col>

        <el-col :span="10">
          <el-row type="flex" justify="end">
            <el-form-item label=" " >
              <el-button @click="adicionarSignatario" type="success">Adicionar</el-button>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>

      <el-row :gutter="22" style="display: flex; justify-content: space-between;">
        <el-col :span="12">
          <el-collapse-transition>
            <div v-show="isShowRepresentantes">
              <el-table
                :data="clienteSelecionado.representantes"
                empty-text="Sem dados"
                height="150px"
                size="small"
                style="background-color: #FFFFFF;"
                highlight-current-row
                stripe
                @row-dblclick="preencherFormularioComRepresentante"
              >
                <el-table-column label="Nome" prop="nome" show-overflow-tooltip/>
                <el-table-column label="Email" prop="email" show-overflow-tooltip/>
                <el-table-column label="CPF" prop="cpf" show-overflow-tooltip/>
              </el-table>
            </div>
          </el-collapse-transition>
        </el-col>
      </el-row>
      
      <el-row :gutter="24" style="display: flex; justify-content: space-between;">
        <el-col :span="22">
          <el-form-item>
            <template style="margin-bottom: 5px;">
              Signatários Adicionados
            </template>
            <el-table
            :data="envolvidosContrato"
            empty-text="Sem dados"
            height="200px"
            size="small"
            style="background-color: #FFFFFF; border: solid 1px #DBDFE5; border-radius: 5px;"
            highlight-current-row
            stripe
            >
              <el-table-column label="Name" prop="nome" show-overflow-tooltip/>
              <el-table-column label="Email" prop="email" show-overflow-tooltip/>
              <el-table-column label="CPF" prop="cpf" show-overflow-tooltip/>
              <el-table-column label="Tipo" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ getLabel(tiposSignatarios, scope.row.tipoSignatario) }}
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    
    <span slot="footer">
      <el-button @click="gravarSignatariosHandler" type="success" size="small">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import Util from '../../../util/funcoes'

import { TIPO_SIGNATARIO_ALUGUEL, TIPO_SIGNATARIO_IMOVEL_ALUGUEL, TIPO_SIGNATARIO_VENDA } from '../../../util/constantes'; 

export default {
  props: {
    visibility: Boolean,
    aluguel: Object,
    venda: Object,
    assinatura: Object,
  },

  data() {
    return {
      form: {
        nome: undefined,
        email: undefined,
        dataNascimento: undefined,
        cpf: undefined,
        tipoSignatario: undefined,
      },

      validacao: {
        nome: [ { required: true } ],
        email: [ { required: true } ],
        cpf: [ { required: true, validator: this.validatorCpf } ],
        tipoSignatario: [ { required: true } ]
      },

      envolvidosContrato: [],

      clienteSelecionado: {},

      loadingClientes: false,

      isTestemunha: false
    }
  },

  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    ...mapState('assinaturaEletronicaStore', {
      listaClientes(state) { return state.listaClientes }
    }),

    tiposSignatarios() {
      if(!this.assinatura) {
        return null;
      }

      switch (this.assinatura.tipo) {
        case 'ALUGUEL':
          return TIPO_SIGNATARIO_ALUGUEL;
        case 'VENDA':
          return TIPO_SIGNATARIO_VENDA;
        case 'IMOVEL_ALUGUEL':
          return TIPO_SIGNATARIO_IMOVEL_ALUGUEL
        default:
          return null;
      }
    },

    isShowRepresentantes() {
      return this.clienteSelecionado.personalidadeJuridica == 'PESSOA_JURIDICA'
    },

    isAssinaturaAluguel() {
      return this.assinatura.tipo === 'ALUGUEL';
      
    },
    isAssinaturaVenda() {
      return this.assinatura.tipo === 'VENDA';
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('assinaturaEletronicaStore', [
      'listarClientes',
      'gravarSignatarios',
      'listarAssinaturas'
    ]),

    cpfIsValido(cpf) {
        return Util.validarCpf(cpf);
      },

    validatorCpf(rule, value, callback) {
      if (this.cpfIsValido(value)) {
        return callback();
      } else {
        return callback(new Error());
      }
    },

    adicionarSignatario() {
      this.$refs['form'].validate(isValid => {

        if(isValid) {
          const signatario = {
            nome: this.form.nome,
            email: this.form.email,
            dataNascimento: this.form.dataNascimento,
            cpf: this.form.cpf,
            tipoSignatario: this.form.tipoSignatario,
            cliente: {
              id: this.clienteSelecionado.id
            }
          };

          if(!this.form.dataNascimento) {
            this.$message.warning('A data de nascimento do signatário precisa está cadastrada.')
            return;
          }

          this.envolvidosContrato.push(signatario);
          return;
        }

        this.$message.warning('Preencha todos os campos.')
      });
    },

    gravarSignatariosHandler() {
      if(this.aluguel && this.aluguel.id > 0) {
        this.gravarSignatariosAluguelHandler();
      } else if( this.venda && this.venda.id > 0) {
        this.gravarSignatariosVendaHandler();
      }
    },

    gravarSignatariosAluguelHandler() {
      const payload = {
        id: this.assinatura.id,
        signatarios: this.envolvidosContrato,
        aluguel: {
          id: this.aluguel.id
        }
      }

      this.showLoading();
      this.gravarSignatarios(payload)
      .then(resultado => {
        switch (resultado.status) {
          case 'SUCESSO':
            this.$message.success('Signatários gravados com sucesso.');
            this.listarAssinaturas({});
            break;
          case 'ERRO':
            this.$message.success('Erro ao gravar signatários.');
            break;
          default:
            this.$message.success('Erro ao conectar-se com o servidor')
        }
      }).catch(() =>{
        this.$message.success('Erro ao conectar-se com o servidor');
      }).finally(() => {
        this.hideLoading();
      })
    },

    gravarSignatariosVendaHandler() {
      const payload = {
        id: this.assinatura.id,
        signatarios: this.envolvidosContrato,
        venda: {
          id: this.venda.id
        }
      }

      this.showLoading();
      this.gravarSignatarios(payload)
      .then(resultado => {
        switch (resultado.status) {
          case 'SUCESSO':
            this.$message.success('Signatários gravados com sucesso.');
            this.listarAssinaturas({});
            break;
          case 'ERRO':
            this.$message.success('Erro ao gravar signatários');
            break;
          default:
            this.$message.success('Erro ao conectar-se com o servidor');
        }
      }).catch(() =>{
        this.$message.success('Erro ao conectar-se com o servidor');
      }).finally(() => {
        this.hideLoading();
      });
    },

    formatarSelectCliente(cliente){
      return Util.formatarSelectCliente(cliente);
    },

    recuperarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString
      
      this.loadingClientes = true;
      this.listarClientes(payload)
      .then(() => {
        this.loadingClientes = false;
      })
    },

    preencherFormularioComCliente() {
      this.resetForm();
      
      if(this.clienteSelecionado.personalidadeJuridica == 'PESSOA_JURIDICA') {
        this.exibirAlert('Atenção', 'Clientes Pessoa Jurídica necessitam de um representante legal, selecione o representante para este cliente na tabela abaixo.');
        return;
      }

      this.form.nome = this.clienteSelecionado.nome
      this.form.email = this.clienteSelecionado.email
      this.form.dataNascimento = this.clienteSelecionado.dataNascimento
      this.form.cpf = this.clienteSelecionado.cpfCnpj
    },

    preencherFormularioComRepresentante(row) {
      this.resetForm();

      this.form.nome = row.nome;
      this.form.email = row.email;
      this.form.dataNascimento = row.dataNascimento;
      this.form.cpf = row.cpf;
    },

    clickTestemunhaCheckBox() {
      if(this.isTestemunha == true) {
        this.clienteSelecionado = {};
        this.resetForm();
        this.form.tipoSignatario = 'TESTEMUNHA';
      }
    },

    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },

    getLabel(lista, valor) {
      return Util.getLabel(lista, valor)
    },

    resetForm() {
      this.form = {
        nome: undefined,
        email: undefined,
        cpf: undefined,
        tipoSignatario: undefined,
        idCliente: undefined,
      }
    },

    reset() {
      this.envolvidosContrato = [];
      this.resetForm();
    },

    fechar() {
      this.reset();
      this.$emit('close');
    }
  }
}
</script>